import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderFillNowResponseImplEncoder } from "../../encoder/OrderFillNowResponseImplEncoder";

import * as CubiqTS from "../../index";
import { OrderFillNowResponse } from "../OrderFillNowResponse";

export class OrderFillNowResponseImpl extends ConcreteEncodable implements OrderFillNowResponse {
  public static enType: string = "com.bcdfx.model.event.OrderFillNowResponseImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderFillNowResponseImplEncoder.Instance;
    this.setEncodableType(OrderFillNowResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderFillNowResponseImpl[" +
      "orderId=" +
      this.orderId +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
